import React from 'react';
import { InputNumber, Switch, Typography } from 'antd';
// Types
import { ChannelMonetizationMilestoneType } from 'api/graphql-global-types';
import { MilestoneRow } from './types';
// Constants
import { MILESTONE_LABELS } from './constants';
// Styles
import styles from './MilestonesEditor.module.scss';

const { Text } = Typography;

type MilestonesEditorProps = {
  milestones: MilestoneRow[];
  onChange: (
    type: ChannelMonetizationMilestoneType,
    patch: Partial<MilestoneRow>
  ) => void;
};

const MilestonesEditor: React.FC<MilestonesEditorProps> = ({
  milestones,
  onChange,
}) => (
  <div className={styles.milestonesSection}>
    <div className={styles.sectionTitle}>Milestone targets</div>
    <Text className={styles.helperText}>
      Set per-milestone target counts and toggle enabled. Disabling a milestone
      after the month is open removes it from creators&apos; progress
      immediately.
    </Text>

    {milestones.map((milestone) => (
      <div key={milestone.type} className={styles.milestoneRow}>
        <div className={styles.milestoneLabel}>
          {MILESTONE_LABELS[milestone.type]}
        </div>
        <InputNumber
          min={1}
          value={milestone.target}
          onChange={(value) =>
            onChange(milestone.type, { target: Number(value ?? 0) })
          }
          style={{ width: '100%' }}
        />
        <Switch
          size="small"
          checked={milestone.enabled}
          onChange={(checked) => onChange(milestone.type, { enabled: checked })}
        />
      </div>
    ))}
  </div>
);

export default MilestonesEditor;
